import React, {Component} from 'react'
import {Field, reduxForm} from 'redux-form'
import {connect} from 'react-redux'
import * as actions from '../../actions/venue'

const form = reduxForm({
  form: 'newvenue',
  validate,
})

const renderField = (
  {input, label, type, meta: {asyncValidating, touched, error}},
) => (
  <div>
    <label>{label}</label>
    <div className={asyncValidating ? 'async-validating' : ''}>
      <input
        {...input}
        type={type}
        placeholder={label}
        className="form-control"
      />
      {touched && error && <div className="error">{error}</div>}
    </div>
  </div>
)

export class NewVenue extends Component {
  handleFormSubmit(formProps) {
    this.props.newVenue(formProps)
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return (
        <div className="alert alert-danger">
          <strong>Oops!</strong> {this.props.errorMessage}
        </div>
      )
    }
  }

  render() {
    const {handleSubmit} = this.props

    return (
      <div>
        <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
          <button action="submit" className="btn btn-success float-xs-right">
            Save
          </button>
          <blockquote className="blockquote">
            <h1>Create Venue</h1>
          </blockquote>
          <div className="well">
            <fieldset className="form-group">
              <Field
                name="name"
                type="text"
                component={renderField}
                label="Venue Name"
              />
            </fieldset>
            <fieldset className="form-group">
              <Field
                name="address"
                type="text"
                component={renderField}
                label="Venue Address"
              />
            </fieldset>
            <fieldset className="form-group">
              <Field
                name="city"
                type="text"
                component={renderField}
                label="Venue City"
              />
            </fieldset>
            <fieldset className="form-group">
              <Field
                name="postcode"
                type="text"
                component={renderField}
                label="Venue Postcode"
              />
            </fieldset>
            <fieldset className="form-group">
              <Field
                name="country"
                type="text"
                component={renderField}
                label="Venue Country"
              />
            </fieldset>
            {this.renderAlert()}
          </div>
        </form>

      </div>
    )
  }
}

function validate(formProps) {
  const errors = {}

  if (!formProps.name) {
    errors.name = 'Please enter a venue name'
  }

  if (!formProps.address) {
    errors.address = 'Please enter a venue address'
  }

  if (!formProps.city) {
    errors.city = 'Please enter a venue city'
  }

  if (!formProps.postcode) {
    errors.postcode = 'Please enter a postcode'
  }

  if (!formProps.country) {
    errors.country = 'Please enter a country'
  }

  return errors
}

function mapStateToProps(state) {
  return {
    venue: state.venue,
  }
}

export default connect(mapStateToProps, actions)(form(NewVenue))



/** WEBPACK FOOTER **
 ** ./src/components/venues/new.js
 **/